import $ from 'jquery';
import widgetFactory from '../../widgetFactory';
import MediaVideoService from '../../../Services/Media/video';

export const widgetName = 'blockedVideoPlayer';

// widget definition
let widget = widgetFactory(widgetName, {
  options: {
    elementWrapper: '<div>',
  },

  _create: function () {
    this._super(widgetName);

    const $thumb = $(MediaVideoService.videoToThumbnail(this.element));
    const $wrapper = $thumb
      .wrapAll(this.options.elementWrapper)
      .parent()
      .addClass(`${widgetName}  js-${widgetName}`);

    this.elements.$thumb = $thumb;
    this.element = $wrapper;
  },
});

export default widget;
